import type { ParentComponent } from "solid-js";

type ExpandClickAreaProps = {
  class?: string;
  debug?: boolean;
};
const ExpandClickArea: ParentComponent<ExpandClickAreaProps> = (props) => (
  <div
    class="relative flex items-center"
    classList={{
      [props.class ?? ""]: true,
      "*:before:opacity-70 *:before:outline-default *:before:-outline-offset-1 *:before:outline-dashed": props.debug,
      // oxlint-disable-next-line better-tailwindcss/no-restricted-classes
      "*:before:absolute *:before:inset-0 *:before:content-['']": true,
    }}
  >
    {props.children}
  </div>
);

export default ExpandClickArea;
